import { log } from "@hoylu/client-common";
import { ReportService, TaskService } from "@hoylu/nexus-service";
import type { RootState } from "typesafe-actions";
import { selectNexusService } from "../../state/config/config.selector";

export type ReportFilters = {
  to?: string;
  from?: string;
  query?: string;
  filters: Record<string, string[]>;
};

export const getNexusTaskService = (state: RootState) =>
  new TaskService({
    // biome-ignore lint/style/noNonNullAssertion: TODO: [User Story 20221: Address `noNonNullAssertion`/`noNonNullAssertedOptionalChain` Biome.js issues](https://hoylu.visualstudio.com/production/_workitems/edit/20221)
    // biome-ignore lint/suspicious/noNonNullAssertedOptionalChain: TODO: [User Story 20221: Address `noNonNullAssertion`/`noNonNullAssertedOptionalChain` Biome.js issues](https://hoylu.visualstudio.com/production/_workitems/edit/20221)
    scopeId: state.context.workspaces.selectedProject?.id!,
    server: selectNexusService(state),
    credentialProvider: () => state.context.user,
    logger: log,
  });

export const getNexusReportService = (state: RootState) =>
  new ReportService({
    // biome-ignore lint/style/noNonNullAssertion: TODO: [User Story 20221: Address `noNonNullAssertion`/`noNonNullAssertedOptionalChain` Biome.js issues](https://hoylu.visualstudio.com/production/_workitems/edit/20221)
    // biome-ignore lint/suspicious/noNonNullAssertedOptionalChain: TODO: [User Story 20221: Address `noNonNullAssertion`/`noNonNullAssertedOptionalChain` Biome.js issues](https://hoylu.visualstudio.com/production/_workitems/edit/20221)
    scopeId: state.context.workspaces.selectedProject?.id!,
    server: selectNexusService(state),
    credentialProvider: () => state.context.user,
    logger: log,
  });
